import request from '@/utils/zsm-requets'

const shipinhaoShop = '/zsm/api/shipinhao/shop/' //视频号小店

/**
 * 删除商品 
 * @param goodId 商品ID
 * @returns 
 */
export function shipinhaoShopDelGood(goodId) {
  return request({
    url: shipinhaoShop + 'delGood',  
    method: 'get',
    params:{goodId}
  })
}



/**
 * 更新商品佣金比例 
 * @param {data} (参照数据库)
 * @returns 
 */
export function updateShipinhaoGoodRatio(data) {
  return request({
    headers: {
      'Content-Type': 'application/json'
    },
    url: shipinhaoShop + 'updateShipinhaoGoodRatio',
    method: 'post',
    transformRequest: [function(data) {
      data = JSON.stringify(data)
      return data
    }],
    data
  })
}



/**
 * 新增联盟商品 
 * @param {data} (参照数据库)
 * @returns 
 */
export function createAllianceGood(data) {
  return request({
    headers: {
      'Content-Type': 'application/json'
    },
    url: shipinhaoShop + 'createAllianceGood',
    method: 'post',
    transformRequest: [function(data) {
      data = JSON.stringify(data)
      return data
    }],
    data
  })
}
/**
 * 查询联盟商品 
 * @param productId 商品ID
 * @returns 
 */
export function findAllianceGood(productId) {
  return request({
    url: shipinhaoShop + 'findAllianceGood',  
    method: 'get',
    params:{productId}
  })
}

/**
 * 更新联盟商品 
 * @param {data} 商品信息
 * @returns 
 */
export function updateAllianceGood(data) {
  return request({
    headers: {
      'Content-Type': 'application/json'
    },
    url: shipinhaoShop + 'updateAllianceGood',
    method: 'post',
    transformRequest: [function(data) {
      data = JSON.stringify(data)
      return data
    }],
    data
  })
}



/**
 * 商品列表 
 * @param {params} (参数参数参照数据库)
 * @returns 
 */
export function findGoodShipinhao(params) {
  return request({
    url: shipinhaoShop + 'findGood',  
    method: 'post',
    params
  })
}
/**
 * 修改商品 
 * @param {data} (参照数据库)
 * @returns 
 */
export function updateGoodShipinhao(data) {
  
    return request({
      headers: {
        'Content-Type': 'application/json'
      },
      url: shipinhaoShop + 'updateGood',
      method: 'post',
      transformRequest: [function(data) {
        data = JSON.stringify(data)
        return data
      }],
      data
    })
}

/**
 * 上架商品 
 * @param goodId 商品ID
 * @returns 
 */
export function listingGoodShipinhao(goodId) {
  return request({
    url: shipinhaoShop + 'listingGood',  
    method: 'get',
    params:{goodId}
  })
}

/**
 * 下架商品 
 * @param goodId 商品ID
 * @returns 
 */
export function delistingGoodShipinhao(goodId) {
  return request({
    url: shipinhaoShop + 'delistingGood',  
    method: 'get',
    params:{goodId}
  })
}






/**
 * 创建商品 
 * @param {data} (参照数据库)
 * @returns 
 */
export function createGoodShipinhao(data) {
    return request({
      headers: {
        'Content-Type': 'application/json'
      },
      url: shipinhaoShop + 'createGood',
      method: 'post',
      transformRequest: [function(data) {
        data = JSON.stringify(data)
        return data
      }],
      data
    })


  }
  /**
 * 保存草稿商品 
 * @param {params} (参数参数参照数据库)
 * @returns 
 */
  export function saveGoodShipinhao(data) {
    return request({
      headers: {
        'Content-Type': 'application/json'
      },
      url: shipinhaoShop + 'saveGood',
      method: 'post',
      transformRequest: [function(data) {
        data = JSON.stringify(data)
        return data
      }],
      data
    })
  }

  
 /**
   * 查询商品 
   * @param  goodId 键ID
   * @returns 
   */
  export function queryGoodShipinhao(goodId) {
    return request({
      url: shipinhaoShop + 'queryGood',
      method: 'post',
      params:{goodId}
    })
  }
  
    



/**
 * 删除达人
 * @param id 主键ID
 * @returns 
 */
export function deleteDistShipinhao(id) {
    return request({
      url: shipinhaoShop + 'deleteDist',
      method: 'get',
      params:{id}
    })
  }
/**
 * 查询达人详情
 * @param distId 主键ID
 * @returns 
 */
  export function getDistDetail(distId) {
    return request({
      url: shipinhaoShop + 'getDistDetail',
      method: 'get',
      params:{distId}
    })
  }
  

/**
 * 新增达人
 * @param distId 账号
 * @param distName 名字
 * @returns 
 */
export function saveDistShipinhao(params) {
    return request({
      url: shipinhaoShop + 'saveDist',
      method: 'post',
      params
    })
  }

/**
 * 查询达人
 * @param distCode 账号
 * @param distName 名字
 * @param loginCode 讲师账号
 * @returns 
 */
export function findDistShipinhao(params) {
  return request({
    url: shipinhaoShop + 'findDist',
    method: 'post',
    params
  })
}

/**
 * 
 * @param  id  类目ID
 * @param  level  类目层级 1 一级 2二级 3三级
 * @returns 
 */
export function findShipinhaoCategory(id,level) {
    return request({
      url: shipinhaoShop + 'findShipinhaoCategory',
      method: 'post',
      params:{
        id,
        level
      }
    })
  }